module.exports = __webpack_public_path__ + "ca1ae89fc69b9feb7bd0657b65efc6ee.png";